export const ru = {
    add_services_title: 'Добавьте услуги',
    can_execute_title: 'Можно оформлять',
    add_services_description: 'Для оформления нужно, чтобы в заявку была добавлена хотя бы одна услуга',
    can_execute_description: 'После нам нужно будет все согласовать и оформить добавленные услуги',
};
